import { cssIf, cssMixin } from "../../utils/styledMixins";
import { isUndefined } from "../../utils/helpers/typeHelper";

const getWidth = ({ width }) => width ?? "auto";

export const widthMixin = cssMixin`
  ${cssIf(({ width }) => !isUndefined(width))`
    width: 100%;
    max-width: ${getWidth};
  `}
`;